import { Fragment, type ReactNode } from 'react';
import {
  ActionSchema,
  ChildListSchema,
  DynamicStringSchema,
} from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { ArtifactGroup } from './ArtifactGroup';

interface ResolvedProps {
  readonly label?: string;
  readonly countLabel?: string;
  readonly totalSizeLabel?: string;
  /** Child ArtifactRow component IDs, in display order. */
  readonly children?: readonly string[];
  readonly onDownloadAll?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  label: DynamicStringSchema,
  countLabel: DynamicStringSchema,
  totalSizeLabel: DynamicStringSchema,
  children: ChildListSchema,
  onDownloadAll: ActionSchema,
}) as any;

export const ArtifactGroupImpl = createComponentImplementation(
  { name: 'ArtifactGroup', schema },
  ({
    props,
    buildChild,
  }: Readonly<{
    props: ResolvedProps;
    buildChild: (childId: string) => ReactNode;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    context: any;
  }>) => (
    <ArtifactGroup
      label={props.label}
      countLabel={props.countLabel}
      totalSizeLabel={props.totalSizeLabel}
      onDownloadAll={props.onDownloadAll}
    >
      {/* ChildListSchema is a union — it also admits a `{componentId, path}`
          template form — so guard before mapping, as CopyQuote does. */}
      {(Array.isArray(props.children) ? props.children : []).map((childId) => (
        <Fragment key={childId}>{buildChild(childId)}</Fragment>
      ))}
    </ArtifactGroup>
  )
);
